import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Navigation,
  Pagination,
} from "../homePage/Shared/CustomSwiper";
import Breadcrump from "../../Components/Breadcrump";
import Card from "../products/ProductCard";
import CategoryCard from "./Card";
import categoryApi from "../../api/categoryApi";

function CategoryDetails() {
  const { slug } = useParams();
  const [item, setItem] = useState({});
  const [subcategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [metaData, setMetaData] = useState({});

  const fetchCategoryDetail = async () => {
    try {
      const catRes = await categoryApi.details(slug);
      

      if (catRes.code === 200) {
        const result = catRes.data;

        setItem(result.category || {});
        setSubCategories(result.subcategories || []);
        setProducts(result.products || []);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  useEffect(() => {
    fetchCategoryDetail();
  }, [slug]);

  return (
    <>
      <Breadcrump title={item?.name} />

      {/* <SEO meta={metaData} /> */}

      {subcategories?.length > 0 && (
        <section className="subcategory-section py-5">
          <div className="container">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              slidesPerView={1}
              spaceBetween={20}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              breakpoints={{
                0: { slidesPerView: 1.8 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
              }}
            >
              {subcategories.map((subcategory) => (
                <SwiperSlide key={subcategory._id || subcategory.name}>
                  <CategoryCard item={subcategory} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      )}

      {/* PRODUCTS SECTION */}
      {products && products.length > 0 ? (
        <div className="py-4 bg-white">
          <div className="container">
            <div className="flat-animate-tab flat-controltab-nav">
              <div className="text-start">
                <h4 className="section-title">Our Products</h4>
              </div>
              <div className="row g-3 mt-2">
                {products.map((product) => (
                  <div className="col-lg-3 col-6 mb-2" key={product._id}>
                    <Card item={product} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-5 bg-white">
          <div className="container">
            <div className="text-center">
              <p>No Product Found in {item?.name} category</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CategoryDetails;
